import { Component } from "react";
import InputGroup from "./InputGroup";
import ContextualHelp from "../Contextuals/ContextualHelp";

type Props = {
  input?: $TSFixMe;
  label?: string;
  disabled?: boolean;
  hidden?: boolean;
  autoFocus?: boolean;
  autoComplete?: string;
  type?: string;
  min?: string;
  max?: string;
  prefix?: $TSFixMe | string;
  placeholder?: string;
  handleChange?: $TSFixMeFunction;
  handleBlur?: $TSFixMeFunction;
  name?: string;
  isSubmitting?: boolean;
  values?: $TSFixMe | $TSFixMe[];
  customClass?: string;
  onPaste?: $TSFixMeFunction;
  help?: boolean;
  helpTitle?: string;
  helpText?: string;
};

class TextInput extends Component<Props> {
  inputField: $TSFixMe;

  componentDidMount() {
    if (this.props.autoFocus) {
      this.focus();
    }
  }

  focus() {
    setTimeout(() => {
      /* istanbul ignore next */
      if (this.inputField) {
        this.inputField.focus();
      }
    }, 50);
  }

  render() {
    const {
      input,
      label,
      disabled,
      type,
      min,
      max,
      prefix,
      placeholder,
      help,
      helpTitle,
      helpText,
      customClass = "",
    } = this.props;
    let inputRender;
    // REDUX FORM
    if (input) {
      inputRender = (
        <input
          {...input}
          onChange={input.onChange}
          className={`form-control ${customClass}`}
          placeholder={placeholder || label}
          type={type || "text"}
          style={{ display: this.props.hidden ? "none" : null }}
          value={input.value}
          disabled={disabled}
          ref={(i) => {
            this.inputField = i;
          }}
        />
      );
      //  FORMIK
    } else {
      const {
        handleChange,
        handleBlur,
        name,
        values,
        isSubmitting,
        onPaste,
        autoComplete = "",
      } = this.props;
      inputRender = (
        <input
          {...input}
          className={`form-control ${customClass}`}
          disabled={disabled || isSubmitting}
          name={name}
          data-testid={name}
          autoComplete={autoComplete || name}
          onChange={handleChange}
          onBlur={handleBlur}
          onPaste={onPaste}
          step="any"
          placeholder={placeholder || label}
          ref={
            /* istanbul ignore next */ (i) => {
              this.inputField = i;
            }
          }
          type={type || "text"}
          style={{ display: this.props.hidden ? "none" : null }}
          min={min}
          max={max}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          value={name.split(".").reduce((p, c) => p?.[c], values) || ""}
        />
      );
    }

    const textInputRender = prefix ? (
      <div className="input-group">
        <span
          className={
            disabled ? "input-group-addon disabled" : "input-group-addon"
          }
        >
          {prefix}
        </span>
        {inputRender}
      </div>
    ) : (
      inputRender
    );

    const contextualHelp = help ? (
      // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      <ContextualHelp title={helpTitle} interactive>
        <p> {helpText} </p>
      </ContextualHelp>
    ) : null;

    return (
      <InputGroup {...this.props} help={contextualHelp}>
        {textInputRender}
      </InputGroup>
    );
  }
}

export default TextInput;
